// app/frontend/components/ui/Buttons/DisabledButton.tsx
import React, { forwardRef } from 'react';
import { Button, ButtonProps } from '@mantine/core';

interface DisabledButtonProps extends Omit<ButtonProps, 'disabled'> {
  children: React.ReactNode;
}

const DisabledButton = forwardRef<HTMLButtonElement, DisabledButtonProps>(
  ({ children, variant = 'filled', color = 'orange', size = 'md', fullWidth, style, className, ...props }, ref) => {
    return (
      <Button
        ref={ref}
        variant={variant}
        color={color}
        size={size}
        fullWidth={fullWidth}
        disabled
        className={`clear-button ${className || ''}`}
        style={{
          marginLeft: 'auto',
          display: 'block',
          ...style,
        }}
        {...props}
      >
        {children}
      </Button>
    );
  },
);

DisabledButton.displayName = 'DisabledButton';

export default DisabledButton;
